import React from 'react';
import { connect } from 'react-redux';
import FormBuilder from "./FormBuilder";

const Home = props => (
    <div>
        <FormBuilder onChange={(values) => console.log(values.formData)} />
    </div>
);

export default connect()(Home);
